import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/iframe-lots-icon.png'


const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = {
  key: 1,
  class: "side-panel-content"
}
const _hoisted_3 = {
  key: 0,
  class: "stage-panel-header"
}
const _hoisted_4 = {
  key: 0,
  class: "side-panel-title mt"
}
const _hoisted_5 = {
  key: 0,
  class: "side-panel-title mt"
}
const _hoisted_6 = {
  key: 1,
  class: "lots-panel-header"
}
const _hoisted_7 = { class: "lots-panel-back" }
const _hoisted_8 = { class: "side-panel-title bold stage" }
const _hoisted_9 = { class: "side-panel-title available-lots" }
const _hoisted_10 = { class: "content-container" }
const _hoisted_11 = {
  key: 0,
  class: "stages-container"
}
const _hoisted_12 = {
  key: 0,
  class: "no-stages-info-wr"
}
const _hoisted_13 = {
  key: 1,
  class: "lots-container"
}
const _hoisted_14 = {
  key: 2,
  class: "estate-map-blocks-side-panel"
}
const _hoisted_15 = { class: "estate-map-block" }
const _hoisted_16 = { class: "estate-map-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["map-side-panel-container", { builderView: $setup.props.builderView }])
  }, [
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!$setup.props.isStageMap)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "side-panel-title bold" }, "Masterplan", -1)),
                (!$setup.props.builderView)
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_4, "Land for sale"))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      ($setup.props.lotsByHouseDesigns)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_5, _toDisplayString($setup.props.lotsByHouseDesigns.length) + " Suitable lots", 1))
                        : _createCommentVNode("", true)
                    ], 64)),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "divider stages" }, null, -1))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "button-with-icon back no-text",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toMasterplan')))
                  }),
                  _cache[5] || (_cache[5] = _createElementVNode("h6", { class: "lots-panel-back__title" }, "Masterplan", -1))
                ]),
                _createElementVNode("h5", _hoisted_8, "Stage " + _toDisplayString($setup.actualStage[0]?.stage?.title), 1),
                _createElementVNode("h5", _hoisted_9, _toDisplayString($setup.actualStage[0]?.lotData?.length) + " Available lots", 1),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "divider" }, null, -1))
              ])),
          _createElementVNode("div", {
            class: _normalizeClass(["side-panel-wrapper scroll-wrapper", { 'lots-side-panel': $setup.props.isStageMap }])
          }, [
            _createElementVNode("div", _hoisted_10, [
              (!$setup.props.isStageMap)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lotsList, (stage) => {
                      return (_openBlock(), _createBlock($setup["StageButtonLink"], {
                        key: stage.stage.id,
                        stage: stage.stage,
                        lotsAvailableAmount: stage.lotData.length,
                        hoverStageId: $setup.props.hoverStageId,
                        onOnStageHover: $setup.onStageHover,
                        onOnClick: $setup.onStageClick
                      }, null, 8, ["stage", "lotsAvailableAmount", "hoverStageId"]))
                    }), 128)),
                    ($setup.lotsList.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[7] || (_cache[7] = [
                          _createElementVNode("img", {
                            class: "no-stages-icon",
                            src: _imports_0
                          }, null, -1),
                          _createElementVNode("div", { class: "no-stages-info" }, "Currently, there is no land available. Join our waitlist to get notified about the next release.", -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.actualStage[0]?.lotData, (lot) => {
                      return (_openBlock(), _createBlock($setup["LotButtonLink"], {
                        lot: lot,
                        hoverLotId: $setup.props.hoverLotId,
                        builderView: $setup.props.builderView,
                        onOnLotHover: $setup.onLotHover,
                        onOnLotBuilderHover: $setup.onLotBuilderHover,
                        onOnClick: $setup.onLotClick
                      }, null, 8, ["lot", "hoverLotId", "builderView"]))
                    }), 256))
                  ]))
            ])
          ], 2),
          (!$setup.props.builderView && !$setup.props.hideOptions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    class: "button primary w-100",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onRegister')))
                  }, "Join Waitlist")
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    class: "button primary w-100",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onMessage')))
                  }, "Message")
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 2))
}